export const ESSENTIAL_PLAN_TYPE = 'pro_essential';
export const ADVANCED_PLAN_TYPE = 'pro_advanced';

export const PACKAGE_TYPES = [ESSENTIAL_PLAN_TYPE, ADVANCED_PLAN_TYPE] as const;
export const PACKAGE_TYPES_WITH_FIVERR = ['fiverr', ...PACKAGE_TYPES] as const;
export type PackageType = (typeof PACKAGE_TYPES)[number];
export type PackageTypeWithFiverr = (typeof PACKAGE_TYPES_WITH_FIVERR)[number];

export interface CurrentPlanDetails {
    _id: string;
    context: {
        type: 'user' | 'organization';
        id: string;
    };
    packageType: PackageType;
    type: 'free' | 'monthly_payment';
    unitPriceInCents: number;
    startDate?: string;
    endDate?: string;
    status: 'active' | 'pending' | 'suspended' | 'ended';
    downgradeRequest?: boolean;
    upgradeRequests?: {
        userId: number;
    }[];
    totalSpent: number;
    extendedEndDate?: string;
}
